import React, {Component, useState} from "react";
import apiHelper from "./ApiHelper";
import {
    Backdrop,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel, InputLabel, OutlinedInput,
    Paper,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import RegFormPopUp from "./RegFormPopUp";
import {MuiTelInput} from "mui-tel-input";

export default class RegistrationApply extends Component {
    constructor(props) {
        super(props);

        this.state = {

            agreement: true,
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '+420',
            insuranceNumber: '',
            Note: '',
            RootURL: apiHelper.GetRootUrlWithCurrentDomain(),
            ApiURL: apiHelper.GetUrlWithCurrentDomain("wp-json/reservation-plugin/controller"),
        };
        this.GdprDialogTitle = "Souhlas s GDPR";
        this.GdprDialogBody = "Pro dokončení objednání musíte souhlasit se zpracováním osobních údajů.";
        this.dialogRef = React.createRef();
        this.GDPR = React.createRef();
        this.TimeLimit = 5000;

        this.processForm = this.processForm.bind(this);

    }


    OpenDialog(_dialogBody, _dialogTitle, _callback, _dialogBtnAgreeText = "SOUHLASÍM") {
        this.setState({
            dialogTitle: _dialogTitle,
            dialogBody: _dialogBody,
            dialogCallback: _callback
        }, () => {
            console.log(this.dialogRef);
            if (this.dialogRef.current !== null) {
                this.dialogRef.current.Open(this.state.dialogBody, this.state.dialogTitle, _dialogBtnAgreeText);
            }
        });
    }

    processForm(event) {
        if (event != null)
            event.preventDefault();
        let result = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            insuranceNumber: this.state.insuranceNumber,
            note: this.state.Note,
        };

        let formData = new FormData();
        formData.append("action", "registration")
        formData.append("user", JSON.stringify(result));


        fetch(this.state.ApiURL, {
            method: 'post',
            body: formData
        }).then(response => {
            if (response.ok)
                return response.json();
            else
                throw new Error("nastala chyba");
        }).then((str) => {
            return str
        })
            .then(str => {

                /*console.log("Data:", JSON.stringify(str));
                console.log("Typ:", typeof str);
                console.log("Porovnání:", str.trim() === "1");*/
                var text = "";
                if (str.trim() === "1") {
                    console.log("Otevírám dialog");
                    text = "Žádost o registraci úspěšně uložena";

                } else {
                    text = "Žádost o registraci nebyla úspěšně uložena"
                }

                this.OpenDialog(text, "Stav registrace", () => {
                    this.setState({
                        open: false
                    });
                    window.location = this.state.RootURL;
                }, "OK");
            })

    }

    render() {

        return (
            <>
                <Backdrop
                    sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                    open={this.state.ShowLoadingBar}
                >
                    <CircularProgress color="inherit"/>
                </Backdrop>
                <div>
                    <RegFormPopUp ref={this.dialogRef} AgreementCallback={this.state.dialogCallback}/>
                    <form onSubmit={this.processForm} style={{fontSize: "18px"}}>
                        <Stack spacing={2}>
                            {/*  <FormControl fullWidth={true}>*/}
                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink htmlFor="FirstName">Jméno</InputLabel>
                                <OutlinedInput
                                    id="FirstName"
                                    required
                                    value={this.state.firstName}
                                    onChange={e => this.setState({firstName: e.target.value})}
                                    label="Jméno"
                                />
                            </FormControl>

                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink htmlFor="LastName">Příjmení</InputLabel>
                                <OutlinedInput
                                    id="LastName"
                                    required
                                    value={this.state.lastName}
                                    onChange={e => this.setState({lastName: e.target.value})}
                                    label="Příjmení"
                                />
                            </FormControl>

                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink htmlFor="Email">Email</InputLabel>
                                <OutlinedInput
                                    id="Email"
                                    type="email"
                                    required
                                    value={this.state.email}
                                    onChange={e => this.setState({email: e.target.value})}
                                    label="Email"
                                />
                            </FormControl>

                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink htmlFor="InsuranceNumber">Číslo pojištěnce</InputLabel>
                                <OutlinedInput
                                    id="InsuranceNumber"
                                    required
                                    value={this.state.insuranceNumber}
                                    onChange={e => this.setState({insuranceNumber: e.target.value})}
                                    label="Číslo pojištěnce"
                                />
                            </FormControl>

                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink htmlFor="PhoneNumb">Telefonní číslo</InputLabel>
                                <MuiTelInput
                                    id="PhoneNumb"
                                    defaultCountry="cz"
                                    disableDropdown={false}
                                    required
                                    value={this.state.phoneNumber}
                                    onChange={value => this.setState({phoneNumber: value})}
                                />
                            </FormControl>

                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink htmlFor="Note">Poznámka</InputLabel>
                                <OutlinedInput
                                    id="Note"
                                    multiline
                                    rows={4}
                                    value={this.state.Note}
                                    onChange={e => this.setState({Note: e.target.value})}
                                    label="Poznámka"
                                />
                            </FormControl>

                            <FormControlLabel
                                ref={this.GDPR}
                                control={<Checkbox value={this.state.agreement} checked={this.state.agreement}
                                                   onChange={this.handleAgreement}/>}
                                label={
                                    <div><Typography>Souhlasím s
                                        <a
                                            href={this.state.PDFURL} target={"_blank"}> podmínkami</a></Typography>

                                    </div>
                                }/>
                            <Button type={"submit"} color={"primary"} variant={"contained"}>Rezervovat</Button>
                            {/*  </FormControl>*/}
                        </Stack>
                    </form>
                </div>
            </>


        )
    }
}